<template>
	<div
		class="fetch-error-banner sgnl-flex sgnl-align-start sgnl-gap-16 sgnl-paragraph-s-regular sgnl-text-color-error"
	>
		<ErrorOutline16 class="sgnl-flex-shrink-0 sgnl-icon-align-text sgnl-icon-color-error" />
		<div class="fetch-error-banner__message">{{ accessState.message }}</div>
		<div
			v-if="accessState.retryable || (showViewTask && taskID)"
			class="sgnl-flex sgnl-gap-8 sgnl-flex-shrink-0"
		>
			<v-btn
				v-if="accessState.retryable"
				:size="size"
				variant="flat"
				color="primary"
				:loading="accessState.loading"
				@click="$emit('retry')"
			>
				Retry
			</v-btn>
			<v-btn
				v-if="showViewTask && taskID"
				:size="size"
				variant="outlined"
				color="primary"
				:to="{ name: 'TaskDetail', params: { id: taskID } }"
			>
				View task
			</v-btn>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { RemoteAccessState } from "@/types/general";
import ErrorOutline16 from "@carbon/icons-vue/es/error--outline/16";

export default defineComponent({
	name: "FetchErrorBanner",
	components: { ErrorOutline16 },
	emits: ["retry"],
	props: {
		accessState: { type: Object as PropType<RemoteAccessState>, required: true },
		showViewTask: { type: Boolean, default: false },
		taskID: { type: String, default: undefined },
		size: { type: String, default: "small" },
	},
});
</script>

<style scoped>
.fetch-error-banner {
	padding: var(--sgnl-space-12) var(--sgnl-space-24);
	border: var(--sgnl-border-width-1) solid var(--sgnl-alert-error-border);
	background: var(--sgnl-alert-error-background-primary);
	border-radius: var(--sgnl-border-radius-6);
}

.fetch-error-banner__message {
	flex: 1;
	min-width: 0;
}
</style>
